/**
 * Authorization Slice
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GET } from '../../api';
import axios from 'axios';
let cancelToken;

// GETTING CALLED WHEN:
// CENTER IS CHANGED
// ON FIRST TIME WEBSITE LOADED
export const refreshLogin = createAsyncThunk('login/refresh-login', async (payload = null) => {
    if (cancelToken) {
        cancelToken.abort();
    }
    cancelToken = new AbortController();
    try {
        let req_params = {}
        if (payload) {
            if (payload.center_id) {
                req_params.center_id = payload.center_id
            }
            if (payload.tenant_id) {
                req_params.tenant_id = payload.tenant_id
            }
        }
        const response = await GET('login/refresh-login', {
            params: req_params,
            signal: cancelToken.signal,
        });
        return {
            data: response.data
        };
    } catch (error) {
        if (axios.isCancel(error)) {

        } else {

        }
        return {
            data: {
                type: false
            }
        };
    }

})

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        authenticated: false,
        authData: {},
        refreshing: false,
        loginTime: null,
    },
    reducers: {
        setAuthentication: (state, action) => {
            state.authData = action.payload;
            state.authenticated = true;
            state.loginTime = new Date().getTime();
        },
        unsetAuthentication: (state) => {
            state.authData = {};
            state.authenticated = false;
            state.loginTime = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(refreshLogin.pending, (state, action) => {
            if (!state.refreshing) {
                state.refreshing = true;
            }
        })
        builder.addCase(refreshLogin.fulfilled, (state, action) => {
            if (state.refreshing === true && action.payload) {
                let res = action.payload.data
                if (res.type) {
                    state.authData = res.data
                    state.refreshing = false;
                } else {
                    state.authenticated = false
                    state.authData = {}
                    state.refreshing = false;
                    window.location.reload();
                }
            }
        })
        builder.addCase(refreshLogin.rejected, (state, action) => {
            // console.log('refreshLogin.rejected', refreshLogin.rejected);
            // if (axios.isCancel(thrown)) {

            // } else 
            if (state.refreshing === true) {
                state.authenticated = false
                state.authData = {}
                state.refreshing = false;
                state.loginTime = null;
                window.location.reload();
            }
        })
    }
});

export const { setAuthentication, unsetAuthentication } = authSlice.actions;
export default authSlice.reducer;
